import { CSSProperties } from "react";
import useMeasure from "util/useMeasure";
import defaultValue from "util/defaultValue";

export default function useScreensHeight() {
  const [{ height: basicHeight }, basicRef] = useMeasure<HTMLDivElement>();
  const [{ height: advancedHeight }, advancedRef] =
    useMeasure<HTMLDivElement>();

  return {
    basicRef,
    basicHeight: defaultValue<CSSProperties["height"]>({
      value: basicHeight,
      defaultValue: "auto",
      predicate: (x) => typeof x === "number" && x > 0,
    }),

    advancedRef,
    advancedHeight: defaultValue<CSSProperties["height"]>({
      value: advancedHeight,
      defaultValue: "auto",
      predicate: (x) => typeof x === "number" && x > 0,
    }),
  };
}
